import { Box, Button } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { FieldWrapperVertical, ReadOnly } from '@ui-framework/index';
import { observer } from 'mobx-react';
import { forwardRef, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ChangeMainContactModal from './UpdateMainContactModal';
import { formatUSPhoneNumber } from '../PhoneNumber/index';

/*
Data Format
{
  id:
  recordVersion
  user:{
    id:
    firstName
    lastName
    email
    phoneNumber
  }
}
*/
const ServiceProviderMainContact = forwardRef((props, ref) => {
  const { getValues, control } = useFormContext();
  const serviceProviderId = getValues('serviceProviderId');
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const currentValue = getValues(props?.name);

  // form permission inject from field generator
  const showChangeButton = props?.permission === 'WRITE';

  return (
    <Controller
      name={props?.name}
      control={control}
      render={({ field }) => {
        const { value } = field;
        const readOnlyUser = value?.user || value;
        return (
          <Box ref={ref}>
            <Grid2 container>
              <FieldWrapperVertical
                field={{
                  name: 'firstName',
                  label: {
                    localeId: 'MAINCONTACT_FIRSTNAME_LABEL',
                    defaultMessage: 'First Name',
                  },
                }}>
                <ReadOnly name="firstName">
                  {readOnlyUser?.firstName || ''}
                </ReadOnly>
              </FieldWrapperVertical>
              <FieldWrapperVertical
                field={{
                  name: 'lastName',
                  label: {
                    localeId: 'MAINCONTACT_LASTNAME_LABEL',
                    defaultMessage: 'Last Name',
                  },
                }}>
                <ReadOnly name="lastName">
                  {readOnlyUser?.lastName || ''}
                </ReadOnly>
              </FieldWrapperVertical>
              <FieldWrapperVertical
                field={{
                  name: 'email',
                  label: {
                    localeId: 'MAINCONTACT_EMAIL_LABEL',
                    defaultMessage: 'Email',
                  },
                }}>
                <ReadOnly name="email">{readOnlyUser?.email || ''}</ReadOnly>
              </FieldWrapperVertical>
              <FieldWrapperVertical
                field={{
                  name: 'phoneNumber',
                  label: {
                    localeId: 'MAINCONTACT_PHONENUMBER_LABEL',
                    defaultMessage: 'Phone Number',
                  },
                }}>
                <ReadOnly name="phoneNumber">
                  {formatUSPhoneNumber(readOnlyUser?.phoneNumber) || ''}
                </ReadOnly>
              </FieldWrapperVertical>
              {showChangeButton && (
                <Button
                  style={{ padding: 0, height: '30px', marginTop: '10px' }}
                  size="small"
                  variant="contained"
                  onClick={() => setOpenUpdateModal(true)}>
                  {props?.field?.action === 'NEW' ? 'Select' : 'Change'}
                </Button>
              )}
            </Grid2>
            <ChangeMainContactModal
              open={openUpdateModal}
              onClose={() => {
                setOpenUpdateModal(false);
              }}
              serviceProviderId={serviceProviderId}
              setOpenModal={setOpenUpdateModal}
              action={props?.field?.action}
              onChange={updatedValue => {
                const newValue = {
                  id: currentValue?.id,
                  recordVersion: currentValue?.recordVersion,
                  user: {
                    id: updatedValue?.id,
                    firstName: updatedValue?.firstName,
                    lastName: updatedValue?.lastName,
                    email: updatedValue?.email,
                    phoneNumber: updatedValue?.phoneNumber,
                  },
                };
                field.onChange(newValue);
              }}
            />
          </Box>
        );
      }}
    />
  );
});

export default observer(ServiceProviderMainContact);
